module.exports = __webpack_public_path__ + "static/media/GLORY_8330.0af9371b.jpg";